/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import jobObj from '../../../objects/jobObj.js';
import jobUtil from '../../../objects/jobUtil.js';
import ko from 'knockout';
//import _ from 'lodash';
import moment from 'moment';
//import axios from 'axios';
import $ from 'jquery';

class jobHistoryModel {

    constructor(params) {

        // Profile
        this.componentName = "jobHistoryModel";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.componentMessenger = params.componentMessenger;
        this.selectedJob = params.selectedJob;

        this.JobHistoryArray = ko.observableArray([]);

        this.context.eventManager.subscribe(() =>{
            console.log("job-history:constructor: jobHistoryRefresh  selectedJob: %o", this.selectedJob);
            if(this.selectedJob.editorVisible() == true)
            {
                this.getJobHistoryList();
            }
            
        },this, "jobHistoryRefresh");


        this.init();
    }

    init() {

        this.componentMessenger.subscribe((messengerObj) => {
            console.log("job-history:componentMessenger:subscribe messengerObj: %o", messengerObj);
            console.log(messengerObj);

            if(messengerObj.visible)
            {
                console.log(this.selectedJob);
                this.getJobHistoryList();

            }
        });

    }

    getJobHistoryList() {

        let jobUtilObj = new jobUtil(this.context);
        this.JobHistoryArray([]);
        this.JobHistoryArray.valueHasMutated();

        console.log("getJobHistoryList selectedJob: %o", this.selectedJob);

        jobUtilObj.getJobVersionHistory(this.selectedJob.jobid()).then( response => {
            console.log("job-history:getJobHistoryList:");
            console.log(response);

            this.JobHistoryArray(response);
            this.JobHistoryArray.valueHasMutated();

            console.log(this.JobHistoryArray());

        }).then(response => {
            console.log("job-history:getJobHistoryList:");
        });

    }

    formatDate(date)
    {
        return moment(date).format('L') + " " + moment(date).format('LT');
    }

    revertVersion(item) {
        console.log('job-history:revertVersion item: %o', item);
        
    }

    viewVersion(item, parent) {
        console.log('job-history:viewVersion item: %o  parent %o', item, parent);
        parent.context.eventManager.notifySubscribers(item,"viewJobVersion");
    }

}

export default { viewModel: jobHistoryModel, template: require('!raw-loader!./job-history.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/job-history/job-history.js